import { MaklerKundeHandle, SteuerberaterKundeHandle } from '../../../generated/api/kreditportalBackendAPI.schemas';

export class KundenHandle {

    vsnr = '';
    nameVn = '';
    freigegeben = false;

    $_clientOfMaklerOrStbr = false;
    $_directKunde = false;
    $_clientOfFirmenverbund = false;

    protected doDeserialize(input: any): KundenHandle {
        this.vsnr = input['vsnr'];
        this.nameVn = input['nameVn'];
        this.freigegeben = input['freigegeben'];

        return this;
    }

    static ofVermittlerKundenHandle(handle: SteuerberaterKundeHandle | MaklerKundeHandle): KundenHandle {
        const result = new KundenHandle();
        result.vsnr = handle.vsnr;
        result.nameVn = handle.nameVn;
        result.freigegeben = handle.freigegeben;
        result.$_clientOfMaklerOrStbr = true;
        result.$_directKunde = false;

        return result;
    }

    static fromData(
        vsnr: string,
        nameVn: string,
        clientOfMaklerOrStbr = false,
        directKunde = false
    ): KundenHandle {
        const result = new KundenHandle();
        result.vsnr = vsnr;
        result.nameVn = nameVn;
        result.$_clientOfMaklerOrStbr = clientOfMaklerOrStbr;
        result.$_directKunde = directKunde;

        return result;
    }

    static copy(oldHandle: KundenHandle): KundenHandle {
        const result = new KundenHandle();
        result.vsnr = oldHandle.vsnr;
        result.nameVn = oldHandle.nameVn;
        result.$_clientOfMaklerOrStbr = oldHandle.$_clientOfMaklerOrStbr;
        result.$_directKunde = oldHandle.$_directKunde;
        result.$_clientOfFirmenverbund = oldHandle.$_clientOfFirmenverbund;

        return result;
    }

    static forFirmenverbundPartner(vsnr: string, nameVn: string): KundenHandle {
        const result = new KundenHandle();
        result.vsnr = vsnr;
        result.nameVn = nameVn;
        result.$_clientOfFirmenverbund = true;

        return result;
    }

}
